import * as actions from '../constants'
import {random} from "../utils";

const inititalState = {
  loadingPosts: true,
  loadingPostsError: null,
  deletingPost: false,
  deletingPostError: null,
  randomXs: {},
  randomYs: {},
  posts: []
}

export default (state = inititalState, action) => {
  switch (action.type) {
    case actions.LOAD_POSTS_REQUEST:
      return {
        ...state,
        posts: [],
        loadingPosts: true,
        loadingPostsError: null
      }
    case actions.LOAD_POSTS_SUCCESS:
    {
      let randomXs = {...state.randomXs}
      let randomYs = {...state.randomYs}
      action.payload.forEach(p=>{
        if(!randomXs[p._id]){
          randomXs[p._id] = random()
        }
        if(!randomYs[p._id]){
          randomYs[p._id] = random()
        }
      })
      return {
        ...state,
        posts: action.payload,
        randomXs,
        randomYs,
        loadingPosts: false,
        loadingPostsError: null
      }
    }
    case actions.LOAD_POSTS_FAILURE:
      return {
        ...state,
        loadingPosts: false,
        loadingPostsError: action.payload
      }
    case actions.CREATE_POST_SUCCESS:
    {
      let posts = state.posts ? state.posts.slice() : []
      posts.unshift(action.payload.post)
      let randomXs = {...state.randomXs}
      let randomYs = {...state.randomYs}
      randomXs[action.payload.post._id] = random()
      randomYs[action.payload.post._id] = random()
      return {
        ...state,
        randomXs,
        randomYs,
        posts,
      }
    }
    case actions.DELETE_POST_REQUEST:
      return {
        ...state,
        deletingPost: true,
        deletingPostError: null
      }
    case actions.DELETE_POST_SUCCESS:
      return {
        ...state,
        posts: state.posts.filter(p=>p._id != action.payload),
        deletingPost: false,
        deletingPostError: null
      }
    case actions.DELETE_POST_FAILURE:
      return {
        ...state,
        deletingPost: false,
        deletingPostError: action.payload
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/posts.js